import "jquery-validation";

$(document).ready(function() {
  $(".star-rating").each(function() {
    const $category = $(this);
    const categoryName = $category.data("category");

    for (let i = 1; i <= 5; i++) {
      const $star = $("<span>")
        .addClass("star")
        .html("★")
        .attr("data-value", i);

      // Hover Effect
      $star.on("mouseover", function() {
        $category.find(".star").each(function(index) {
          $(this).toggleClass("hovered", index < i);
        });
      });

      // Remove Hover Effect
      $star.on("mouseout", function() {
        $category.find(".star").removeClass("hovered");
      });

      // Click Event
      $star.on("click", function() {
        $category.find(".star").each(function(index) {
          $(this).toggleClass("selected", index < i);
        });

        // Update hidden input field
        $(`#${categoryName}-rating`).val(i);
      });

      $category.append($star);
    }
  });


  $("#new_feedback").validate({
    errorClass: "error_message",

    rules: {
      "feedback[name]": {
        required: true,
        minlength: 3,
        maxlength: 40
      },
      "feedback[email]": {
        email: true
      },
      "feedback[phone_number]": {
        required: true,
        number: true,
        minlength: 10,
        maxlength: 10
      }
    },

    messages: {
      "feedback[name]": {
        required: "Please enter your name",
        minlength: "Please enter a valid name",
        maxlength: "Name should not have more than 40 chars"
      },
      "feedback[email]": {
        email: "Please enter a valid email"
      },
      "feedback[phone_number]": {
        required: "Please enter 10 digit mobile number",
        number: "Please enter a numeric value",
        minlength: "Please enter 10 digit mobile number",
        maxlength: "Please enter 10 digit mobile number"
      }
    },

    submitHandler: function(form) {
      if ($(form).valid()) {
        form.submit();
      }
    }
  });
});
